@if (!isAggregated) {
  <div class="point-name-row">
    <div class="point-name">
      <gc-text [variant]="'minorHeading'">{{ properties.name }}</gc-text>
    </div>
    @if (isKpWithLeadIdPresent(properties)) {
      <app-popup-pdf-download-trigger
        [isLoading]="pdfController.isPdfDownloadInProgress"
        [tooltip]="downloadTooltipLabel"
        (trigger)="onDownloadPreviewPdf(properties, $event)"
        (triggerKeydown)="onDownloadPreviewPdfKeyDown(properties, $event)"
      />
    }
  </div>
  <hr />
  <app-duct-popup-content
    [reportStatus]="properties | kpReportStatus: pointStatuses()"
    [multiDuctInformation]="multiDuctProperties"
    [ductInformation]="subDuctProperties"
    [pointConnectedTo]="
      properties.aggregatedMarkerReferences?.[0]?.connectedToAddress ?? null
    "
  />
  @if (isKpWithLeadIdPresent(properties)) {
    <div class="report-btn">
      <gc-button
        [variant]="'primary'"
        [size]="'full'"
        (clicked)="openReport(properties)"
      >
        {{ 'report.open' | translate }}
      </gc-button>
    </div>
  }
  <div class="close-button">
    <gc-button
      [variant]="'secondary'"
      [size]="'full'"
      (clicked)="onClosePopup()"
    >
      {{ 'close' | translate }}
    </gc-button>
  </div>
} @else {
  <div class="aggregated-container">
    @for (point of sortedAggregatedReferences; track point.id) {
      <div class="point-item">
        <div
          class="point-header"
          (click)="togglePoint(point.id)"
          (keydown.enter)="togglePoint(point.id)"
        >
          <gc-text [variant]="'minorHeading'">{{ point.name }}</gc-text>
          <gc-icon
            [iconName]="isPointExpanded(point.id) ? 'chevronUp' : 'chevronDown'"
            [size]="'medium'"
            [color]="'primary'"
          />
        </div>
        @if (isPointExpanded(point.id)) {
          <div class="point-info-container">
            <app-duct-popup-content
              [reportStatus]="point | kpReportStatus: pointStatuses()"
              [multiDuctInformation]="point.duct ?? null"
              [ductInformation]="point.subDuct ?? null"
              [pointConnectedTo]="point.connectedToAddress ?? null"
            />
            @if (isKpWithLeadIdPresent(point)) {
              <div class="aggregated-actions-row">
                <gc-button
                  [variant]="'primary'"
                  [size]="'small'"
                  [icon]="'chevronRight'"
                  [iconPosition]="'right'"
                  (clicked)="openReport(point)"
                >
                  {{ 'report.open' | translate }}
                </gc-button>
                <app-popup-pdf-download-trigger
                  [isLoading]="pdfController.isPdfDownloadInProgress"
                  [tooltip]="downloadTooltipLabel"
                  (trigger)="onDownloadPreviewPdf(point, $event)"
                  (triggerKeydown)="onDownloadPreviewPdfKeyDown(point, $event)"
                />
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
  <div class="close-button">
    <gc-button
      [variant]="'secondary'"
      [size]="'full'"
      (clicked)="onClosePopup()"
    >
      {{ 'close' | translate }}
    </gc-button>
  </div>
}
